// extracted by mini-css-extract-plugin
export default {"link":"HeaderNav_link__D-4+B","active":"HeaderNav_active__8AJhp"};